module.exports = __webpack_public_path__ + "img/Small-2-Bevel-Attachment-38.c84f0933.png";